var _module_exports = "<s-multi-select-items\nclass=\"d-block multi-select-modal\"\nitems=\"items\"\non-item-toggle=\"onItemToggle()\"\n/>\n";;
var path = '/common/directives/multiSelect/multiSelectItems/multiSelectItemsModal/multiSelect.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;